// extracted by mini-css-extract-plugin
module.exports = {"title":"_2oA_VM","hint":"_31nNON","field":"_2TVbej","setGiftRecipientInfoModal":"_37vmrl","shine-lines":"_3MN1qJ"};